import React from 'react'

import { bool } from 'prop-types'

function Header({ isSignup }) {
  const title = isSignup ? 'Create your account' : 'Welcome back'
  const subtitle = isSignup
    ? "Join 2.5M+ creators using the world's largest 3D marketplace."
    : 'Log in to keep creating, designing and downloading.'

  return (
    <div className="auth-modal__header-group auth-modal__header-group--center">
      <p className="auth-modal__title cgt-heading-300">{title}</p>
      <p className="auth-modal__subtitle cgt-body-md">{subtitle}</p>
    </div>
  )
}

Header.propTypes = {
  isSignup: bool.isRequired,
}

export default Header
